export const REFERRAL_ITEMS = [
  { localeKey: "roleCustomer", backgroundColor: "#E3F2FD", color: "#2196F3", urlPath: "specialcustomer" },
  { localeKey: "rolePromoter", backgroundColor: "#F3E5F5", color: "#9C27B0", urlPath: "salepromoter", hideWhen: "Customer" },
  { localeKey: "roleManager", backgroundColor: "#FFF8E1", color: "#F7B005", urlPath: "areamanager" },
  {
    localeKey: "roleManagerAssociation",
    backgroundColor: "#FFF3E0",
    color: "#E65100",
    urlPath: "areamanager",
    queryParams: { association: "true" },
    showWhen: "isSubnetLeader",
  },
  { localeKey: "rolePartner", backgroundColor: "#E8F5E9", color: "#4CAF50", urlPath: "businesspartner" },
  { localeKey: "roleSeller", backgroundColor: "#FBE9E7", color: "#272360", urlPath: "seller" },
  { localeKey: "roleStore", backgroundColor: "#FCE4EC", color: "#F06292", urlPath: "storeregister", hideWhen: "Customer" },
];

export const buildReferralUrl = (baseUrl, item, username) => {
  const params = new URLSearchParams({ link: username });
  if (item.queryParams) {
    Object.entries(item.queryParams).forEach(([key, value]) => {
      params.set(key, value);
    });
  }
  return `${baseUrl}/${item.urlPath}?${params.toString()}`;
};

export const filterReferralItems = (items, { userTypeInfo, isSubnetLeader }) =>
  items.filter((item) => {
    if (item.hideWhen && userTypeInfo === item.hideWhen) return false;
    if (item.showWhen === "isSubnetLeader" && !isSubnetLeader) return false;
    return true;
  });
